import {
  ACTIVITY_FORMS_NUMBERS,
  ACTIVITY_FORMS_ORDER,
  ACTIVITY_PRICES_FORMS_NUMBERS,
  ACTIVITY_SCHEDULE_FORMS_NUMBERS
} from 'pages/create-activity/constants';

export const isDiscardChanges = (
  forms,
  formName,
  activeTab,
  newActiveTab,
  savedForms,
  initialFormData,
  dynamicInitialData,
  languages
) => {
  // const formValues = JSON.stringify(forms[formName].values);
  const formValues = JSON.stringify(forms[formName]?.values || {});

  const savedFormValues = JSON.stringify(savedForms[formName]);
  const languagesLength = languages.length;

  if (
    languagesLength > 1 &&
    (formName === 'generalForm' || formName === 'descriptionForm')
  ) {
    const secondLanguage = languages[languagesLength - 1];
    const secondLanguageFormName = `${formName}-${secondLanguage}`;

    const secondLanguageFormValues = JSON.stringify(
      forms[secondLanguageFormName].values
    );
    const secondLanguageSavedFormValues = JSON.stringify(
      savedForms[secondLanguageFormName]
    );

    if (
      activeTab !== newActiveTab &&
      secondLanguageFormValues !== secondLanguageSavedFormValues
    ) {
      return true;
    }
  }

  if (formName === 'addOnsForm') {
    if (activeTab !== newActiveTab && formValues !== savedFormValues) {
      if (!savedFormValues && !forms[formName].values.addOns.length)
        return false;
      return true;
    }
  }

  if (formName === 'mandatoryFeesForm') {
    if (activeTab !== newActiveTab && formValues !== savedFormValues) {
      if (!savedFormValues && !forms[formName].values.mandatoryFees.length)
        return false;
      return true;
    }
  }

  if (
    formName === 'generalForm' &&
    savedForms[formName] &&
    activeTab !== newActiveTab
  ) {
    if (
      forms[formName].values.activityType !== savedForms[formName].activityType
    ) {
      return true;
    }
  }

  if (
    activeTab !== newActiveTab &&
    formValues !== savedFormValues &&
    savedFormValues
  ) {
    if (
      (formName === 'pricesDailyForm' ||
        formName === 'pricesDailyScheduleForm') &&
      formValues === JSON.stringify(dynamicInitialData[formName])
    ) {
      return false;
    }
    return true;
  }

  return false;
};

export const discardChanges = (
  languages,
  formName,
  initializeForm,
  savedForms,
  dynamicInitialData,
  initialFormData,
  newActiveTab,
  activeTab,
  setActiveTab
) => {
  let isError = false;
  const languagesLength = languages.length;
  const secondLanguage = languages[languagesLength - 1];
  const forms = [formName];

  if (
    languagesLength > 1 &&
    (formName === 'generalForm' || formName === 'descriptionForm')
  ) {
    forms.push(`${formName}-${secondLanguage}`);
  }

  for (let i in forms) {
    if (!forms.hasOwnProperty(i)) continue;
    const formName = forms[i];
    let newInitializedForm = {};

    if (
      formName === 'pricesDailyForm' ||
      formName === 'pricesDailyScheduleForm'
    ) {
      initializeForm(
        formName,
        savedForms[formName] || dynamicInitialData[formName]
      );
    } else {
      newInitializedForm =
        savedForms[formName] || initialFormData[formName] || {};
      initializeForm(formName, newInitializedForm);
    }

    if (!savedForms[formName] && newActiveTab >= activeTab) isError = true;

    if (
      formName === 'addOnsForm' &&
      newActiveTab >= activeTab &&
      languagesLength > 1
    ) {
      newInitializedForm.addOns.map(item => {
        if (!item[secondLanguage] || !item[secondLanguage].title) {
          isError = true;
        }
      });
    }
    if (!savedForms[formName] && newActiveTab >= activeTab) isError = true;
    if (
      formName === 'mandatoryFeesForm' &&
      newActiveTab >= activeTab &&
      languagesLength > 1
    ) {
      newInitializedForm.mandatoryFees.map(item => {
        if (!item[secondLanguage] || !item[secondLanguage].title) {
          isError = true;
        }
      });
    }
  }

  if (!isError) setActiveTab(newActiveTab);
};

export const isDiscardSection = (
  activeTab,
  newActiveTab,
  scheduleActiveSubTab,
  pricesActiveSubTab,
  savedForms
) => {
  if (activeTab === newActiveTab) return false;

  if (
    activeTab === ACTIVITY_FORMS_NUMBERS.scheduleForm &&
    savedForms.scheduleTab &&
    savedForms.scheduleTab !==
      ACTIVITY_FORMS_ORDER[activeTab][scheduleActiveSubTab]
  ) {
    return true;
  }

  if (savedForms && savedForms['generalForm']) {
    let pricesTabIndex =
      savedForms['generalForm'].activityType === 'Open'
        ? pricesActiveSubTab + 1
        : pricesActiveSubTab;

    if (savedForms.scheduleTab === 'schedulePassForm') {
      if (
        !savedForms['generalForm'] ||
        savedForms['generalForm'].activityType === 'Open'
      ) {
        pricesTabIndex = 0;
      } else {
        if (pricesActiveSubTab) {
          pricesTabIndex = 1;
        } else {
          pricesTabIndex = 0;
        }
      }
    }

    if (
      activeTab === ACTIVITY_FORMS_NUMBERS.pricesForm &&
      savedForms.pricesTab &&
      savedForms.pricesTab !==
        ACTIVITY_FORMS_ORDER[activeTab][scheduleActiveSubTab][pricesTabIndex]
    ) {
      return true;
    }
  }

  return false;
};

export const discardSection = (
  activeTab,
  newActiveTab,
  setScheduleActiveSubTab,
  setPricesActiveSubTab,
  setActiveTab,
  formName,
  initializeForm,
  savedForms,
  initialFormData,
  dynamicInitialData
) => {
  if (activeTab === ACTIVITY_FORMS_NUMBERS.scheduleForm) {
    const formName = savedForms.scheduleTab;
    setScheduleActiveSubTab(ACTIVITY_SCHEDULE_FORMS_NUMBERS[formName]);
    initializeForm(
      formName,
      savedForms[formName] || initialFormData[formName] || {}
    );
  }

  if (activeTab === ACTIVITY_FORMS_NUMBERS.pricesForm) {
    const formName = savedForms.pricesTab;
    const scheduleSectionIndex =
      ACTIVITY_SCHEDULE_FORMS_NUMBERS[savedForms.scheduleTab];
    let pricesSectionIndex =
      ACTIVITY_PRICES_FORMS_NUMBERS[scheduleSectionIndex][formName];

    if (savedForms['generalForm'].activityType === 'Open') pricesSectionIndex--;

    setPricesActiveSubTab(pricesSectionIndex);

    if (
      formName === 'pricesDailyForm' ||
      formName === 'pricesDailyScheduleForm'
    ) {
      initializeForm(
        formName,
        savedForms[formName] || dynamicInitialData[formName]
      );
    } else {
      initializeForm(
        formName,
        savedForms[formName] || initialFormData[formName] || {}
      );
    }
  }

  setActiveTab(newActiveTab);
};
